<template>
  <InfoPageContainer v-bind="{ id, type, value }">
    <template #header>
      <ScratchcardHeader />
    </template>
  </InfoPageContainer>
</template>

<script lang="ts" setup>
import { INFO_ROUTE_TYPES } from '~/constants/infoRoutes'

definePageMeta({
  key: 'scratchcard-info',
  layout: false,
  middleware: ['info-redirect'],
  validate: async (to) => {
    try {
      const licensedTerritory = useLicensedTerritory({ raw: true })
      await useScratchcardGameLazyQuery({
        licensedTerritory,
        slug: to.params.slug,
      }).load()

      return validateInfoRouteCreator()(to)
    } catch {
      return false
    }
  },
})

const router = useRouter()

const id = computed(() => String(router.currentRoute.value.params.slug))
const type = computed(() => INFO_ROUTE_TYPES.Scratchcard)
const value = computed(() => String(router.currentRoute.value.params.id))
</script>
